import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';
import { jobDetailsNCFileConfig } from './config';

const JobDetailsNCFileStack = createStackNavigator();

const JobDetailsNCFileNavigator = () => {
  return (
    <JobDetailsNCFileStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {jobDetailsNCFileConfig.map(({ Component, name }) => (
        <JobDetailsNCFileStack.Screen key={name} name={name} component={Component} />
      ))}
    </JobDetailsNCFileStack.Navigator>
  );
};

export { JobDetailsNCFileNavigator };
